import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'

Sentry.init({
  enabled: import.meta.env.VITE_ENV === 'PROD',
  dsn: import.meta.env.VITE_SENTRY_DNS as string,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['debug'] }),
    Sentry.browserProfilingIntegration(),
  ],
  tracePropagationTargets: ['localhost', 'skoolib.org', 'skoolib.net'],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: 0.1,
  environment: (import.meta.env.VITE_ENV as string) ?? 'DEV',
})

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)
